import { Component, Input } from '@angular/core';
import { IFromToHyphen } from "libraries/pipes/configurable-table/compute-value.pipe";


@Component({
    selector: 'from-to-hyphen',
    template: `
        <ng-container>
            <span>{{ fromToHyphen?.from}} <strong>-</strong> {{ fromToHyphen?.to }}</span>
        </ng-container>
    `,
    styles: [`
        
    `]
})
export class FromToHyphenComponent {

    @Input()
    public fromToHyphen: IFromToHyphen;
}
